import React from "react";
import { NEUT_BG, LINE } from "../../Bureau/bureauTokens";

const BUBBLE_WIDTHS = [55, 38, 65, 42, 58];

// Squelette du fil de conversation pendant le chargement des messages —
// même structure que le rendu final (en-tête + bulles), bulles alternées
// gauche/droite pour rester visuellement proche du résultat réel.
function ConversationPaneSkeleton() {
  return (
    <div
      className="flex flex-col h-full min-h-0 animate-pulse"
      style={{ background: "#fff", border: `1px solid ${LINE}`, borderRadius: 14 }}
    >
      <div className="flex items-center gap-3 px-4 py-3.5" style={{ borderBottom: `1px solid ${LINE}` }}>
        <span className="flex-shrink-0 rounded-full" style={{ width: 36, height: 36, background: NEUT_BG }} />
        <span className="h-3 rounded" style={{ width: 140, background: NEUT_BG }} />
      </div>
      <div className="flex-1 flex flex-col gap-2.5 px-4 py-4">
        {BUBBLE_WIDTHS.map((w, i) => (
          <span
            key={i}
            className="h-8 rounded-2xl"
            style={{ width: `${w}%`, alignSelf: i % 2 === 0 ? "flex-start" : "flex-end", background: NEUT_BG }}
          />
        ))}
      </div>
    </div>
  );
}

export default ConversationPaneSkeleton;
